// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"61ce25bf","266":"501e4abe","438":"e92b0a22","921":"8a758098","966":"6f995ce2","984":"459aa561"}[chunkId] + ".chunk.js";
};